// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"3ef32a31","328":"8eb89fc6","1275":"d38b7cbb","3524":"ef2f0d4f","7482":"43f97571"}[chunkId] + ".css";
};